import { BrandColors } from '../theme';

export const dialogTokens = {
    root: {
        background: BrandColors.surface[0],
        borderRadius: '12px',
        color: BrandColors.surface[700],
        borderColor: 'none',
    },
    header: {
        padding: '1.25rem 1.5rem',
        gap: '0.5rem',
        fontSize: '1.125rem',
    },
    content: {
        padding: '0 1.5rem 1.5rem',
    },
    footer: {
        padding: '0 1.5rem 1.5rem',
        gap: '0.5rem',
    },
};
